import React from 'react';
import { Redirect } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { storeTokenDetails } from './utils/auth';

const AuthCallback = (props: any) => {
  if (storeTokenDetails(props.location)) {
    return <Redirect to="/" />;
  } else {
    return <div>Something bad happened during authentication</div>;
  }
};

AuthCallback.propTypes = {
  location: PropTypes.object.isRequired
};

export default AuthCallback;
